/** @format */

import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { SURVEY } from "./constants/constants";

const Preview = ({ questionRequestDTOS, description }) => {
  return (
    <div className='survey__preview__container pb-6'>
      <div className='survey__preview__mobile__status__bar'></div>
      <p className='mt-6'>
        <b>Survey Description:</b>
      </p>
      <p className='px-5'>{description}</p>
      <ol className='survey__preview__question__list mt-6'>
        {questionRequestDTOS.map((question, index) => {
          return (
            <li className='mt-4' key={index}>
              <b>{question.name}</b>
              <ul>
                {question.type === SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE ? (
                  question.optionRequestDTOS.map((answer, index) => {
                    return (
                      <li className='py-3 my-2 mr-3' key={index}>
                        <RadioButton value='' name='' checked={false} disabled className='mx-3' />
                        {answer.option}
                      </li>
                    );
                  })
                ) : (
                  <li className='my-2 mr-3'>
                    <InputTextarea readOnly rows={5} />
                  </li>
                )}
              </ul>
            </li>
          );
        })}
      </ol>
      <div className='pb-6'>
        <Button className='cancel' label='Cancel'></Button>
        <Button className='submit' label='Submit'></Button>
      </div>
    </div>
  );
};

export default Preview;
